import type { AxisLabelsFormatterContextObject } from 'highcharts';
import { colors as colorsTokens } from '@eqi-investimentos/tokens';
import { CHART_COLORS, CHART_CONSTRAST_COLORS } from '@/themes/chart';

const BILLION = 1000000000;
const MILLION = 1000000;
const THOUSAND = 1000;

export const getChartAssetColor = (index: number) => {
  const numberOfColors = CHART_COLORS.length;
  if (index < numberOfColors - 1) {
    return CHART_COLORS[index];
  }
  const correctedIndex = index % numberOfColors;
  return CHART_COLORS[correctedIndex];
};

export const getChartAssetContrastColor = (index: number) => {
  const numberOfColors = CHART_CONSTRAST_COLORS.length;
  if (index < numberOfColors - 1) {
    return CHART_CONSTRAST_COLORS[index];
  }
  const correctedIndex = index % numberOfColors;
  return CHART_CONSTRAST_COLORS[correctedIndex];
};

export function formatAxisBigValues(this: AxisLabelsFormatterContextObject) {
  const value = Number(this.value);

  if (value >= BILLION || value <= -BILLION) {
    const billionValue = formatToBRNotation(value / BILLION);
    return `${billionValue}bi`;
  }
  if (value >= MILLION || value <= -MILLION) {
    const millionValue = formatToBRNotation(value / MILLION);
    return `${millionValue}mi`;
  }
  if (value >= THOUSAND || value <= -THOUSAND) {
    const thousandValue = formatToBRNotation(value / THOUSAND);
    return `${thousandValue}k`;
  }

  return `${formatToBRNotation(value)}`;
}

const formatToBRNotation = (value: number) =>
  value.toFixed(1).replace('.', ',');

export const getColorChartAssetByToken = (
  rowIndex: number,
  isDarkMode: boolean
) => {
  const currentTheme = isDarkMode ? 'dark' : 'light';
  const brandColor = getChartAssetColor(rowIndex);

  const tokenPath = brandColor.split('.');
  let color: unknown = (
    colorsTokens as Record<string, Record<string, unknown>>
  )[currentTheme];

  for (const key of tokenPath) {
    color = (color as Record<string, unknown>)?.[key];
  }

  return color as string;
};

export const generateArrayColorsTokens = (
  colors: string[],
  isDarkMode: boolean
) => {
  const currentTheme = isDarkMode ? 'dark' : 'light';

  colors = colors.map((color) => {
    const tokenPath = color.split('.');
    let selectColor: unknown = (
      colorsTokens as Record<string, Record<string, unknown>>
    )[currentTheme];

    for (const key of tokenPath) {
      selectColor = (selectColor as Record<string, unknown>)?.[key];
    }

    return selectColor as string;
  });

  return colors;
};

export const getColorTokenHex = (
  colorToken: string,
  isDarkMode: boolean
): string => {
  const currentTheme = isDarkMode ? 'dark' : 'light';
  const tokenPath = colorToken.split('.');

  let color: unknown = (
    colorsTokens as Record<string, Record<string, unknown>>
  )[currentTheme];

  for (const key of tokenPath) {
    color = (color as Record<string, unknown>)?.[key];
  }

  return color as string;
};
